



















import Vue from 'vue'
import DeliveryAddressModal from '@/product/components/DeliveryAddressModal.vue'
import DeliveryDateModal from '@/product/components/DeliveryDateModal.vue'
import { RecipientAddressType } from '@/types'
import { gaEventTracker, EVENT_LABELS, EVENT_ACTIONS, EVENT_CATEGORIES } from '@/common/utils'
import { data} from '@/product/selectors'
import { UserInfo } from '@/types/common'
import httpClient from '@/common/httpClient'
import { ENDPOINTS } from '@/checkout/constants'
import { getJsonData } from '@/common/utils/dom'
import { ADDRESS_TYPE } from '@/product/const'
export default Vue.extend({
  name: 'DeliveryModal',
  components: {
    DeliveryAddressModal,
    DeliveryDateModal
  },
  props: {
  },
  data(): {
    addressModal: boolean
    zipCode: string
    address: string,
    defaultAddressType: string
    recipientAddressList: RecipientAddressType[]
  } {
    return {
      addressModal: true,
      zipCode: '',
      address: '',
      defaultAddressType: ADDRESS_TYPE.ZIPCODE,
      recipientAddressList: []
    }
  },
  async created() {
    const loggedInUser: UserInfo = getJsonData(data.currentUser)
    if (loggedInUser) {
        const { data } = await httpClient.get<RecipientAddressType[]>(
          ENDPOINTS.RECIPIENT_ADDRESSES
        )
          .catch(error => {
            throw new Error(error)
          })
        this.recipientAddressList = data
      }
  },
  methods: {
    closeModal() {
      this.$emit('onClose')
    },
    selectZipcodeHandler(zipcode: string, address: string, addressType: string) {
      this.zipCode = zipcode
      this.address = address
      this.defaultAddressType = addressType
      this.addressModal = false
      this.eventTracker()
    },
    switchModalHandler() {
      this.addressModal = true
    },
    eventTracker(){
      const isMobile = window.innerWidth < 1024
      let eventLabel
      if (isMobile) {
        eventLabel = this.defaultAddressType === ADDRESS_TYPE.ZIPCODE ? EVENT_LABELS.MOBILE_ZIP_CHECK : EVENT_LABELS.MOBILE_ADDRESS_CHECK
      }
      else {
        eventLabel = this.defaultAddressType === ADDRESS_TYPE.ZIPCODE ? EVENT_LABELS.PC_ZIP_CHECK : EVENT_LABELS.PC_ADDRESS_CHECK
      }
      const payload = {
        category: EVENT_CATEGORIES.PRODUCT_DETAIL,
        action: EVENT_ACTIONS.DECIDE,
        label: eventLabel
      }
      gaEventTracker(payload)
    }
  }
})
